import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import SendIcon from "@mui/icons-material/Send";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";
const PopupForm = ({ closeModal }) => {
  const [modalIsOpen, setModalIsOpen] = useState(true);
  const [deniedDomains, setDeniedDomains] = useState([]);
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [company, setCompany] = useState("");
  const [email, setEmail] = useState("");
  const [mobile, setMobile] = useState("");
  const [code, setCode] = useState("");
  useEffect(() => {
    // Replace 'YOUR_API_ENDPOINT' with the actual URL of your backend API
    axios
      .get("/api/v1/getDeniedMailDomains")
      .then((response) => {
        const domainsObject = response.data.deniedDomains;
        const domains = domainsObject.map((item) => item["*@0-mail"]["com"]);
        setDeniedDomains(domains);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching denied mail domains:", error);
        setLoading(false);
      });
  }, []);
  const handleOpenModal = () => {
    setModalIsOpen(true);
  };

  const handleCloseModal = () => {
    setModalIsOpen(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!/^[6789]\d{9}$/.test(mobile)) {
      // Show an error message for an invalid mobile number
      toast.error("Please enter a valid 10-digit mobile number");
      return; // Exit the function early
    }
    const enteredEmailDomain = "*@" + email.split("@")[1];
    // Check if the entered email domain is in the deniedDomains array
    if (deniedDomains.includes(enteredEmailDomain)) {
      // Show an error message for denied domains
      toast.error("Please enter a valid corporate email");
      return; // Exit the function early
    }
    try {
      // Assuming you have the data to be sent in the 'data' variable
      const response = await axios.post("/api/v1/earlyAccess", {
        name,
        email,
        mobile,
        company,
        code,
      });
      // Handle the response if needed
      // console.log("Response:", response.data);
      // console.log("Response:lkssa", response);
      if (response.data.success) {
        toast.success(
          "Congrats on joining the wishlist. We'll be launching our new offering really soon and the access will be shared based on wishlist status",
          {
            onClose: () => {
              closeModal(); // Call your closeModal function here
              handleCloseModal(); // Call your handleCloseModal function here
            },
          }
        );
      }
    } catch (error) {
      // Handle errors if any
      // console.log("eeeeeeer", error);
      console.error("Error:", error.message);
      toast.error(error?.response?.data?.message, {
        onClose: () => {
          closeModal(); // Call your closeModal function here
          handleCloseModal(); // Call your handleCloseModal function here
        },
      });
    }

    // closeModal();
    // handleCloseModal();
  };

  const customStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.6)",
    },
    content: {
      backgroundColor: "rgb(248 253 255)",
      border: "none",
      borderRadius: "8px",
      boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
      maxWidth: "500px",
      marginTop: "100px",
      marginLeft: "auto ",
      marginRight: "auto ",
      height: "550px",
    },
  };

  return (
    <div className="p-4">
      <Modal
        isOpen={true} // Set to true to open the modal by default
        onRequestClose={closeModal}
        // onRequestClose={handleCloseModal}
        contentLabel="Popup Form"
        style={customStyles}
      >
        <h2 className="text-3xl font-medium">Apply For Early Access</h2>
        <p className="text-sm text-black">
          Join our Wishlist to upgrade your hiring process with cutting edge AI
        </p>
        <form onSubmit={handleSubmit}>
          <TextField
            label="Name"
            variant="filled"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
            fullWidth
            margin="normal"
          />

          <TextField
            label="Company"
            variant="filled"
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            required
            fullWidth
            margin="normal"
          />
          <TextField
            label="Email"
            variant="filled"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            fullWidth
            margin="normal"
          />
          <TextField
            label="Mobile"
            variant="filled"
            value={mobile}
            onChange={(e) => {
              const inputValue = e.target.value;
              // Check if the input value exceeds 10 digits
              const numericValue = inputValue.replace(/\D/g, "");

              // Limit the input to 10 characters
              if (numericValue.length <= 10) {
                setMobile(numericValue); // Update the state with the new value
              }
            }}
            required
            fullWidth
            margin="normal"
            inputProps={{
              maxLength: 10, // Limit the input to a maximum of 10 characters
            }}
          />
          <TextField
            label="Invitation Code"
            variant="filled"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            fullWidth
            margin="normal"
          />

          <div className="text-center">
            <Button
              variant="contained"
              type="submit"
              color="primary"
              endIcon={<SendIcon />}
            >
              Submit
            </Button>
          </div>
        </form>
      </Modal>
    </div>
  );
};

export default PopupForm;
